import React, { useState, useEffect, Fragment, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules'; 
import { AppContext } from '../Home';
import {API_BASE_URL} from '../../../../config';
import 'swiper/css/pagination';
import axios from "axios";
import 'swiper/css';

const Notices = () => {
 
    const { setSlider, setNotice } = useContext(AppContext);
    const [notice_title, setNoticeTitle] = useState(""); 
    const [notices, setNotices] = useState([]); 
   

    useEffect(() => {     
        try {
            axios.get(API_BASE_URL + "/api/posts").then(function (response) {
                if(response.data.notices != undefined) { 
                    setNotices(response.data.notices);
                } 
            }); 
        }
        catch (error) { 
            console.log(error);
        }
    }, []);

    const NoticeList = () => {
        return (   
            notices.length > 0 ?
            <Swiper
            spaceBetween={50}
            slidesPerView={1} 
            autoplay={{ delay: 7000, disableOnInteraction: false, }}
            modules={[Autoplay]} >
            { notices.map((node) => {   
                return(
                    <SwiperSlide key={node.notice_id} onClick={ () => getNotice(node.notice_id) }>{node.notice_title} {(node.areas[0] && node.areas[0].sub_area_name != null ? " in " + node.areas[0].sub_area_name : "")} 
                    { node.notice_category_id == 6 || node.notice_category_id == 14 || node.notice_category_id == 117 ? node.area_display : ""}</SwiperSlide>   
                ) 
            })}
            </Swiper> : <div className='spacer'></div>
        )
    } 
 
    const getNotice = async (id) => {    
        try {
            const response = await axios.get(API_BASE_URL + "/public/notices" + id).then(function (response) {
                if (response.data != undefined && response.data.results != undefined) {  
                    let notice = response.data.results;
                    notice.streets = [];
                    if(notice.notice_area_streets != null)
                    {
                        let streets = notice.notice_area_streets.split(",");  
                        streets.forEach(street => {
                            if(notice.notice_estimated != "" && notice.notice_estimated != null)
                            {
                                notice.streets.push(street.toUpperCase());
                            }
                            else
                            {
                                notice.streets.push(street);
                            }
                            
                        });
                    } 

                    if(notice.category_id == 6)
                    {
                        notice.streets.push("And surrounding areas.");
                    } 
                    
                    setNotice(notice);  
                    setSlider(false);
                }
                else
                {
                    let notice = notices.filter(item => item["notice_id"] == id)[0];
                    notice.streets = notice.notice_area_streets.split(","); 
                    setNotice(notice); 
                    setSlider(false);
                }          
            });
        }
        catch (error) {}     
    }   

    return (  
        <div className="container"> 
            <NoticeList />
        </div>
    );
}


export default Notices;